import { useTranslation } from 'react-i18next';
import i18nInstance from '../../localeImport.js';
import Button from '../Button/Button.js';
import Image from '../Image.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ExternalWalletButton(props) {
  const {
    button,
    handleWalletClick
  } = props;
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  return /*#__PURE__*/jsxs(Button, {
    variant: "tertiary",
    type: "button",
    onClick: () => handleWalletClick(button),
    className: "w3a--w-full w3a--rounded-xl w3a--size-xl !w3a--justify-between w3a--items-center wallet-btn",
    title: button.name,
    children: [/*#__PURE__*/jsxs("div", {
      className: "w3a--flex w3a--items-center",
      children: [/*#__PURE__*/jsx(Image, {
        imageId: `login-${button.name}`,
        hoverImageId: `login-${button.name}`,
        fallbackImageId: "wallet",
        height: "24",
        width: "24",
        isButton: true,
        extension: button.imgExtension
      }), /*#__PURE__*/jsx("p", {
        className: "w3a--ml-2 w3a--text-left w3a--text-sm",
        children: button.displayName
      })]
    }), button.hasInjectedWallet && /*#__PURE__*/jsx("span", {
      className: "w3a--inline-flex w3a--items-center w3a--rounded-lg w3a--px-2 w3a--py-1 w3a--text-xs w3a--font-medium w3a--bg-app-primary-100 w3a--text-app-primary-800",
      children: t("modal.external.installed")
    })]
  });
}

export { ExternalWalletButton as default };
